<script>
  import { accountActionsSection } from './account-actions.js';
</script>

<section class="actions" aria-labelledby="actions-title">
  <h2 id="actions-title">{accountActionsSection.title}</h2>

  <div class="action-list">
    {#each accountActionsSection.links as link}
      {#if link.tone === 'primary'}
        <a class="action action-primary" href={link.href}>{link.label}</a>
      {:else}
        <a class="action action-secondary" href={link.href}>
          <span>{link.label}</span>
          <span class="arrow" aria-hidden="true">→</span>
        </a>
      {/if}
    {/each}
  </div>
</section>

<style>
  .actions {
    padding: 20px;
    border: 1px solid rgba(231, 185, 98, 0.3);
    border-radius: 16px;
    background: rgba(231, 185, 98, 0.04);
  }

  h2 {
    margin: 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
  }

  .action-list {
    margin-top: 16px;
    display: grid;
    gap: 8px;
  }

  .action {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    min-height: 44px;
    padding: 0 16px;
    border-radius: 12px;
    font-size: 14px;
    text-decoration: none;
    transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease;
    box-sizing: border-box;
  }

  .action-secondary {
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.8);
    background: transparent;
  }

  .action-secondary:hover,
  .action-secondary:focus-visible {
    border-color: rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }

  .action-primary {
    justify-content: center;
    border: 0;
    background: #e7b962;
    color: #000000;
    font-weight: 500;
  }

  .action-primary:hover,
  .action-primary:focus-visible {
    background: #ffa800;
  }

  .arrow {
    color: rgba(255, 255, 255, 0.5);
  }
</style>
